(function () {
var $3c866438e2ea0555$exports = {};
const $3c866438e2ea0555$var$getYear = document.getElementsByClassName("getyear");
const $3c866438e2ea0555$var$getDate = document.getElementById("today-date");
const $3c866438e2ea0555$var$now = new Date();
$3c866438e2ea0555$var$getYear[0].textContent = $3c866438e2ea0555$var$now.getFullYear();
$3c866438e2ea0555$var$getYear[1].textContent = $3c866438e2ea0555$var$now.getFullYear();
$3c866438e2ea0555$var$getDate.textContent = $3c866438e2ea0555$var$now.toLocaleDateString("en-NZ", {
    weekday: "long",
    day: "numeric",
    month: "long"
});
// When the user scrolls the page, execute myFunction
window.onscroll = function() {
    $3c866438e2ea0555$var$myFunction();
};
var $3c866438e2ea0555$var$header = document.getElementById("edproj-header-container");
var $3c866438e2ea0555$var$sticky = $3c866438e2ea0555$var$header.offsetTop;
function $3c866438e2ea0555$var$myFunction() {
    if (window.pageYOffset > $3c866438e2ea0555$var$sticky) $3c866438e2ea0555$var$header.classList.add("edproj-header__sticky");
    else $3c866438e2ea0555$var$header.classList.remove("edproj-header__sticky");
}
function $3c866438e2ea0555$var$detectDevice() {
    var minDesktopWidth = 841;
    return document.documentElement.clientWidth < minDesktopWidth ? "mobile" : "desktop";
}
// Support button function
window.digitalData = window.digitalData || {
    page: {
        pageInfo: {
            pageID: "interactive",
            pageName: "Support Stuff's Journalism",
            sysEnv: $3c866438e2ea0555$var$detectDevice(),
            variant: "1",
            version: "1",
            publisher: "",
            articleID: "",
            headline: "",
            author: "",
            source: "",
            lastPublishedTime: ""
        },
        category: {
            pageType: "interactive",
            primaryCategory: "interactive"
        },
        ads: {
            environment: "prod",
            exclusions: "",
            sections: []
        }
    },
    user: [
        {
            profile: [
                {
                    profileInfo: {
                        uid: ""
                    }
                }
            ],
            segment: {}
        }
    ],
    events: []
};
function $3c866438e2ea0555$var$sendEvent(event) {
    if (window.digitalData) window.digitalData.events.push(event);
}
document.addEventListener("DOMContentLoaded", ()=>{
    const heroHeading = document.getElementById("heroHeading");
    const heroImg = document.getElementById("heroImg");
    const dotHolder = document.getElementById("dotHolder");
    const getGradient = document.getElementById("imgGrad");
    const report1 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-1.jpg";
    const report2 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-2.jpg";
    const report3 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-3.jpg";
    const report4 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-4.jpg";
    const report5 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-5.jpg";
    const report6 = "https://interactives.stuff.co.nz/2026/supporter-page-images/report-6.jpg";
    const heroData = [
        {
            text: "Join our mission to make <br> Aotearoa a better place",
            img: report1
        },
        {
            text: "Independent news is a <br> public service for all",
            img: report2
        },
        {
            text: "As fake news spreads, <br>fact-checks are vital",
            img: report3
        },
        {
            text: "From your support, to the <br> newsroom, to the nation",
            img: report4
        },
        {
            text: "Join thousands of Kiwis <br> backing local trusted news",
            img: report5
        },
        {
            text: "If our work matters to you <br> help protect its future",
            img: report6
        }
    ];
    let count = 0;
    let heroInterval;
    heroData.forEach((item)=>{
        const img = new Image();
        img.src = item.img;
    });
    heroHeading.innerHTML = heroData[0].text;
    heroImg.src = heroData[0].img;
    heroData.forEach((item, index)=>{
        const dot = document.createElement("div");
        dot.classList.add("edproj-main-hero-image-dot");
        if (index === 0) dot.classList.add("live-img");
        dot.addEventListener("click", (e)=>{
            e.stopPropagation();
            goToSlide(index);
            startTimer();
        });
        dotHolder.appendChild(dot);
    });
    [
        heroImg,
        getGradient
    ].forEach((element)=>{
        if (element) {
            element.style.cursor = "pointer";
            element.addEventListener("click", ()=>{
                let nextIndex = (count + 1) % heroData.length;
                goToSlide(nextIndex);
                startTimer();
            });
        }
    });
    function updateDots(activeIndex) {
        const allDots = document.querySelectorAll(".edproj-main-hero-image-dot");
        allDots.forEach((dot, index)=>{
            if (index === activeIndex) dot.classList.add("live-img");
            else dot.classList.remove("live-img");
        });
    }
    function goToSlide(index) {
        heroHeading.classList.add("fade-out-text");
        heroImg.classList.add("fade-out-img");
        setTimeout(()=>{
            count = index;
            heroHeading.innerHTML = heroData[count].text;
            heroImg.classList.add("is-loading");
            heroImg.onload = ()=>{
                heroImg.classList.remove("is-loading");
            };
            heroImg.src = heroData[count].img;
            updateDots(count);
            heroHeading.classList.remove("fade-out-text");
            heroImg.classList.remove("fade-out-img");
        }, 500);
    }
    function startTimer() {
        clearInterval(heroInterval);
        heroInterval = setInterval(()=>{
            let nextIndex = (count + 1) % heroData.length;
            goToSlide(nextIndex);
        }, 5000);
    }
    startTimer();
    const supportCards = document.querySelectorAll(".edproj-supports-card");
    const firstCard = supportCards[0];
    const supportWrapper = document.querySelector(".edproj-supports");
    supportCards.forEach((card)=>{
        const cardButton = card.querySelector(".edproj-main__supports--card--button");
        if (cardButton) cardButton.addEventListener("mouseenter", ()=>{
            supportCards.forEach((c)=>c.classList.remove("highlight"));
            card.classList.add("highlight");
        });
    });
    supportWrapper.addEventListener("mouseleave", ()=>{
        supportCards.forEach((c)=>c.classList.remove("highlight"));
        if (firstCard) firstCard.classList.add("highlight");
    });
    const sideSupportCards = document.querySelectorAll(".edproj-side-support-card");
    const sideFirstCard = sideSupportCards[0];
    const sidesupportWrapper = document.querySelector(".edproj-side-support");
    sideSupportCards.forEach((card)=>{
        const cardButton = card.querySelector(".edproj-main__supports--card--button");
        if (cardButton) cardButton.addEventListener("mouseenter", ()=>{
            sideSupportCards.forEach((c)=>c.classList.remove("highlight"));
            card.classList.add("highlight");
        });
    });
    sidesupportWrapper.addEventListener("mouseleave", ()=>{
        sideSupportCards.forEach((c)=>c.classList.remove("highlight"));
        if (sideFirstCard) sideFirstCard.classList.add("highlight");
    });
});

})();
//# sourceMappingURL=index.f0352aaa.js.map
